/* eslint-disable react/no-multi-comp */
import React, { useState } from 'react'
import { Table, Button, Divider, Popconfirm, Row, Col, Tag, Icon ,Card } from 'antd'
import BrandActivityForm from './BrandActivityForm'
import { ButtonEx } from '../../styles/button.style'
import { ACTION } from '../../utils/constants'
import { useDispatch, useSelector } from 'react-redux'
import { useDeepEffect } from '../../utils/hooks'
import {
  createBrandActivity,
  deleteBrandActivity,
  fetchBrandActivityList,
  updateBrandActivity
} from '../../modules/brandActivity'
import PreviewImage from '../../components/PreviewImage'

const BrandActivity = ({ brandId }) => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [visiblePreview, setVisiblePreview] = useState(false)
  const [previewImage, setPreviewImage] = useState(null)
  const [formState, setFormState] = useState(null)
  const [action, setAction] = useState(ACTION.CREATE)

  const { brandActivityList , isLoading } = useSelector(
    (state) => ({
      brandActivityList: state.brandActivity.brandActivityList,
      isLoading:state.brandActivity.isLoading
    }),
    []
  )

  async function fetchData() {
    await dispatch(fetchBrandActivityList(brandId))
  }

  useDeepEffect(() => {
    fetchData()
  }, [])

  const columns = [
    {
      title: 'ID',
      key: 'id',
      dataIndex: 'id'
    },
    {
      title: 'ชื่อกิจกรรม',
      key: 'No',
      dataIndex: 'activityName'
    },
    {
      title: 'ระยะเวลากิจกรรม',
      dataIndex: 'rangeActiveDate',
      key: 'rangeActiveDate'
    },
    {
      title: 'Status',
      key: 'status',
      dataIndex: 'status',
      render: (status) => {
        let color
        switch (status) {
          case 'Active':
            color = 'green'
            break
          case 'Expire':
            color = 'red'
            break
          case 'Inactive':
            color = 'yellow'
            break
        }
        return <Tag color={color}>{status}</Tag>
      }
    },
    {
      title: 'Action',
      key: 'action',
      render: (text, record) => (
        <span>
          <Button
            type="primary"
            size="small"
            shape="circle"
            icon="edit"
            onClick={(e) => onClick(e, ACTION.UPDATE, record)}
          />
          <Divider type="vertical" />
          <Popconfirm
            title="Sure to delete?"
            onConfirm={() => onDelete(record.id)}>
            <Button type="danger" size="small" shape="circle" icon="delete" />
          </Popconfirm>
        </span>
      )
    }
  ]

  async function onOk(data) {
    data.brandId = brandId

    if (action === ACTION.CREATE) {
      await dispatch(createBrandActivity(data))
    } else {
      await dispatch(updateBrandActivity(data))
    }

    await setVisible(false)
    await dispatch(fetchBrandActivityList(brandId))
  }

  async function onDelete(id) {
    await dispatch(deleteBrandActivity(id))
    await dispatch(fetchBrandActivityList(brandId))
  }

  const onClick = (e, type, record) => {
    e.preventDefault()
    setVisible(true)
    setAction(type)

    if (type === ACTION.UPDATE) {
      setFormState(record)
    }
  }

  const onCloseModal = () => {
    setVisible(false)
    setFormState(null)
  }

  return (
    <Card
    title="Brand Product"
    extra={      <Row type="flex">
    <Col span={12}>
    </Col>
    <Col span={12}>
      <Row type="flex" justify="end">
        <ButtonEx
          color="#6ebf4b"
          type="primary"
          onClick={(e) => onClick(e, ACTION.CREATE)}>
          <Icon type="plus" /> เพิ่มกิจกรรม
        </ButtonEx>
      </Row>
    </Col>
  </Row>}>
      <PreviewImage
        imgUrl={previewImage}
        visible={visiblePreview}
        onClose={() => {
          setVisiblePreview(false)
          setPreviewImage(null)
        }}
      />
      <Table
        loading={isLoading}
        bordered
        dataSource={brandActivityList}
        columns={columns}
      />
      <BrandActivityForm
        action={action}
        formState={formState}
        visible={visible}
        onOk={onOk}
        onCancel={onCloseModal}
      />
    </Card>
  )
}

export default BrandActivity



// WEBPACK FOOTER //
// ./src/pages/BrandActivity/index.js